import React, { useState, useEffect } from "react";
import { TextField, Button, Grid, Dialog, DialogContentText, Autocomplete } from "@mui/material";
import PropTypes, { number } from "prop-types";
import { EditUserApi } from "api/UserAPI";
import "dayjs/locale/vi";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { loadSelectRole } from "api/rolesService";
import Swal from "sweetalert2";
import { commonTextLabelStyle } from "styles/muiStyles";
import { useColorTheme } from "../../../context/ColorThemeContext";

function EditUser({ refreshDataAfterChage, open, onClose, userToEdit }) {
  const colors = useColorTheme();
  const [userData, setUserData] = useState({
    fullname: "",
    email: "",
    phoneNumber: "",
    roleId: "",
    departmentId: "",
    administrativeAreaId: "",
    partnerId: "",
    username: "",
    fullNameLeader1: "",
    fullNameLeader2: "",
  });
  const [responseData, setResponseData] = useState({
    message: "",
    status: number,
  });
  const [optionRoles, setOptionRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState(null);

  // Mock data fetching for roles
  const fetchOptionRoles = async () => {
    const response = await loadSelectRole("edit");
    if (response.status === 200) {
      const roles = response.object;
      setOptionRoles(response.object);

      const matchedRole = roles.find((p) => p.id === userToEdit.roleId);

      if (matchedRole) {
        setSelectedRole(matchedRole);
      }
    }
  };

  const formatVNDateToInput = (vnDateStr) => {
    const [day, month, year] = vnDateStr.split("/").map(Number);
    const yyyy = year;
    const mm = month.toString().padStart(2, "0");
    const dd = day.toString().padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };

  useEffect(() => {
    if (open) {
      fetchOptionRoles();
      setUserData({
        userId: userToEdit?.userId || "",
        fullname: userToEdit?.fullName || "",
        email: userToEdit?.email || "",
        phoneNumber: userToEdit?.phone || "",
        username: userToEdit?.username || "",
        roleId: userToEdit?.roleId || "",
        departmentId: userToEdit?.departmentId || "",
        administrativeAreaId: userToEdit?.administrativeAreaId || "",
        partnerId: userToEdit?.partnerId || "",
        hashtagUser: userToEdit?.hashtagUser || "",
        fullNameLeader1: userToEdit?.fullNameLeader1 || "",
        fullNameLeader2: userToEdit?.fullNameLeader2 || "",
        cccd: userToEdit?.cccd || "",
        birthday: userToEdit?.birthday
          ? formatVNDateToInput(new Date(userToEdit?.birthday).toLocaleDateString("vi-VN"))
          : null,
      });
      console.log(userData.birthday);
    }
  }, [open]);

  const handleUpdateUser = () => {
    const birthdayDate = new Date(userData.birthday);
    if (birthdayDate > new Date()) {
      setResponseData({
        message: "Ngày sinh không được lớn hơn ngày hiện tại",
        status: 201,
      });
    } else if (
      userData.fullname === "" ||
      userData.roleId === "" ||
      userData.departmentId === "" ||
      userData.partnerId === "" ||
      userData.administrativeAreaId === ""
    ) {
      setResponseData({
        message: "Nhập thông tin bắt buộc",
        status: 201,
      });
    } else {
      EditUserApi(userData).then((data) => {
        if (data) {
          setResponseData(data);
          if (data.status === 200) {
            Swal.fire({
              title: "Thao tác thành công",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
            });
            onClose();
            refreshDataAfterChage();
          } else {
            Swal.fire({
              title: "Thao tác thất bại",
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
            });
          }
        } else {
          setResponseData({
            message: "Error receive data",
            status: 201,
          });
        }
      });
    }
  };

  const handleClose = () => {
    onClose();
    setSelectedRole(null);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({ ...prevData, [name]: value }));
  };

  return (
    <Dialog
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xxxl"
      open={open}
      onClose={() => {
        setResponseData({
          message: null,
          status: null,
        });
        handleClose();
        onClose();
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
          color: colors.popupText || "white !important",
          padding: "13px 20px",
          fontWeight: "bold",
          fontSize: "18px",
          position: "relative",
        }}
      >
        Chỉnh sửa người dùng
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: "white !important",
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ paddingTop: "10px !important" }}>
        <DialogContentText id="alert-dialog-description">
          <Grid container spacing={3} mb={2} mt={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label={
                  <span>
                    Tên đăng nhập
                    <span style={{ color: "#FF0000" }}>*</span>
                  </span>
                }
                disabled
                className="form-field"
                fullWidth
                name="position"
                value={userData.username}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                // required
                id="outlined-required"
                label={
                  <span>
                    Họ tên
                    <span style={{ color: "#FF0000" }}>*</span>
                  </span>
                }
                className="form-field"
                sx={commonTextLabelStyle}
                fullWidth
                name="fullname"
                value={userData.fullname}
                onChange={handleChange}
                inputProps={{ maxLength: 50 }}
                error={
                  userData.fullname === "" && responseData.message === "Nhập thông tin bắt buộc"
                }
                helperText={
                  userData.fullname === "" && responseData.message === "Nhập thông tin bắt buộc"
                    ? responseData.message
                    : ""
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="CCCD"
                className="form-field"
                fullWidth
                name="cccd"
                value={userData.cccd}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Ngày sinh"
                className="form-field"
                fullWidth
                name="birthday"
                value={userData.birthday ? userData.birthday.split("T")[0] : ""}
                onChange={(event) => {
                  const newDate = event.target.value;
                  setUserData((prevState) => ({
                    ...prevState,
                    birthday: newDate ? new Date(newDate).toISOString() : "",
                  }));
                }}
                error={responseData.message === "Ngày sinh không được lớn hơn ngày hiện tại"}
                helperText={
                  responseData.message === "Ngày sinh không được lớn hơn ngày hiện tại"
                    ? responseData.message
                    : ""
                }
                // onChange={handleChange}
                type="date"
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Email"
                className="form-field"
                fullWidth
                disabled
                name="email"
                value={userData.email}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Số điện thoại"
                className="form-field"
                fullWidth
                name="phoneNumber"
                value={userData.phoneNumber}
                onChange={handleChange}
                disabled
              />
            </Grid>
            {/* Thêm các trường thông tin khác tương tự */}
          </Grid>
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <Autocomplete
                options={optionRoles}
                getOptionLabel={(option) => `${option.name ? `${option.name}` : ""}`}
                onChange={(event, newValue) => {
                  setSelectedRole(newValue);
                  if (newValue !== null) setUserData({ ...userData, roleId: newValue.id });
                }}
                value={selectedRole || null}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <span>
                        Vai trò<span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                    placeholder="Chọn vai trò"
                    error={
                      selectedRole === null || responseData.message === "Nhập thông tin bắt buộc"
                    }
                    helperText={
                      selectedRole === null || responseData.message === "Nhập thông tin bắt buộc"
                        ? responseData.message
                        : ""
                    }
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} mb={2}>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Tên lãnh đạo trực tiếp 1"
                className="form-field"
                fullWidth
                name="fullNameLeader1"
                value={userData.fullNameLeader1}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6} xl={6}>
              <TextField
                InputLabelProps={{
                  shrink: true,
                  color: "primary",
                }}
                sx={commonTextLabelStyle}
                label="Tên lãnh đạo trực tiếp 2"
                className="form-field"
                fullWidth
                name="fullNameLeader2"
                value={userData.fullNameLeader2}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} xl={6} sx={{ display: "none" }}>
            <TextField
              InputLabelProps={{
                shrink: true,
                color: "primary",
              }}
              sx={commonTextLabelStyle}
              label="Mã số user"
              className="form-field"
              placeholder="Mã sinh tự động cú pháp: $Q9_[số điện thoại User]"
              fullWidth
              name="hashtagUser"
              value={userData.hashtagUser}
              onChange={handleChange}
            />
          </Grid>
        </DialogContentText>
      </DialogContent>
      {/* </Container> */}
      <DialogActions
        sx={{
          paddingTop: "0px !important",
          mb: 1,
          justifyContent: "center", // Căn giữa theo chiều ngang
          display: "flex",
        }}
      >
        <Button
          sx={{
            "&.MuiButton-root.MuiButton-contained": {
              boxShadow: "none !important",
              fontWeight: "normal",
              height: "36px !important",
              maxHeight: "36px !important",
            },
            "&.MuiButton-root": {
              minHeight: "36px !important",
            },
          }}
          style={{
            width: "18%",
            borderColor: colors.popupBackground || "var(--blue-blue-100)",
            color: colors.popupBackground || "var(--blue-blue-100)",
            fontWeight: "normal",
          }}
          variant="outlined"
          onClick={() => {
            handleClose();
            setResponseData({
              message: null,
              status: null,
            });
          }}
        >
          Đóng
        </Button>
        <Button
          sx={{
            "&.MuiButton-root.MuiButton-contained": {
              boxShadow: "none !important",
              fontWeight: "normal",
              height: "36px !important",
              maxHeight: "36px !important",
            },
            "&.MuiButton-root": {
              minHeight: "36px !important",
            },
            backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
            color: colors.popupText || "white",
            "&:hover": {
              backgroundColor: colors.popupBackground || "var(--blue-blue-100)",
              boxShadow: "none !important",
            },
          }}
          style={{
            fontWeight: "normal",
            width: "18%",
          }}
          variant="contained"
          onClick={handleUpdateUser}
        >
          Lưu
        </Button>
      </DialogActions>
    </Dialog>
  );
}

EditUser.propTypes = {
  // onUpdateUser: PropTypes.func.isRequired,
  refreshDataAfterChage: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  userToEdit: PropTypes.objectOf(String).isRequired,
};

export default EditUser;
